import { Component, OnInit, Inject, Output, EventEmitter, ViewChild } from '@angular/core';
import { MedioNotifService } from 'src/app/services/med-notif.service';
import { MedioNotif } from 'src/app/models/MedioNotif';
import { Distrito } from 'src/app/models/Distrito';
import { Provincia } from 'src/app/models/Provincia';
import { Departamento } from 'src/app/models/Departamento';
import { FormGroup, FormControl } from '@angular/forms';
import { DistritoService } from 'src/app/services/distrito.service';
import { ProvinciaService } from 'src/app/services/provincia.service';
import { DepartamentoService } from 'src/app/services/departamento.service';
import { ModalNotificacion } from 'src/app/models/ModalNotificacion';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { General } from 'src/app/models/General';
import { NavModalComponent } from '../../General/nav-modal/nav-modal.component';
import { ngClassAceptarModal, ngClassSalirModal, ValidarEmail, NumIdMedioNotifEmail, openModalMensaje, NumIdParamUsuDefCasilla, NumIdLinkRegCasilla } from 'src/app/general/variables';
import { isEmpty, trim } from 'lodash';
import { ParametroService } from 'src/app/services/parametro.service';
import { LaserFicheService } from 'src/app/services/laser-fiche.service';
import { NroDocumentoServicio } from 'src/app/models/nroDocumentoServicio';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-modal-notificacion',
  templateUrl: './modal-notificacion.component.html',
  styleUrls: ['./modal-notificacion.component.css']
})
export class ModalNotificacionComponent implements OnInit {

  listMedioNotif: MedioNotif[] = [];
  listDistrito: Distrito[] = [];
  listProvincia: Provincia[] = [];
  listDepartamento: Departamento[] = [];
  dataReturn: General = new General();

  mostrarCheckCambioEmail = false;
  mostrarCambioEmail = false;
  mostrarCheckDireccion = false;
  mostrarCambioDireccion = false;
  boolFlgCasillaElect = false;


  //
  medioNotificacion: string;
  email: string;
  departamento: string;
  distrito: string;
  provincia: string;
  direccion: string;
  referencia: string;
  strDscTitulo = 'Notificaciones';
  strCorreoPN = '';
  strNroDocPN = '';
  strDscTipoDocPN = '';

  ngClassAceptarModal = ngClassAceptarModal;
  ngClassSalirModal = ngClassSalirModal;
  flgAutorizoEmail = false;
  flgAutorizoActo = false;
  flgMostrarAutoriza = false;
  strCodUsuDef = '';
  strDscLinkCasilla = '';
  //
  formModalNotificacion = new FormGroup({
    // select_medNotif: new FormControl(''),
   // input_dsc_dir: new FormControl(''),
    // input_dsc_ref_dir: new FormControl(''),
    // select_departamento : new FormControl(''),
    // select_provincia : new FormControl(''),
    // select_distrito : new FormControl(''),
    // input_email : new FormControl(''),
    radio_cambemail : new FormControl(''),
    radio_cambdirecc : new FormControl(''),
  });

  @Output() modalEmitter: EventEmitter<FormGroup> = new EventEmitter();
  @ViewChild(NavModalComponent) navModalC: NavModalComponent;

  constructor( private dialogRef: MatDialogRef<ModalNotificacionComponent>,
               @Inject(MAT_DIALOG_DATA) public data: ModalNotificacion,
               protected medioNotifService: MedioNotifService,
               protected distritoService: DistritoService,
               protected provinciaService: ProvinciaService,
               protected departamentoService: DepartamentoService,
               protected parametroService: ParametroService,
               protected laserFicheService: LaserFicheService,

               private spinner: NgxSpinnerService,
               public dialog: MatDialog
    ) { }

  ngOnInit() {

      this.navModalC.setDatosNavModal2(this.strDscTitulo);

      this.medioNotifService.listarMedioNotif().subscribe(
      data => {
        this.listMedioNotif = data;

        this.listMedioNotif.sort(function(a, b) {

          if (a.cmedionotifDsc > b.cmedionotifDsc) {
            return 1;
          }

          if (a.cmedionotifDsc < b.cmedionotifDsc) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });

        // console.log(data);
        this.medioNotificacion = null;
        // this.formModalNotificacion.controls.select_medNotif.setValue(null);
      });

      this.departamentoService.obtenerDepartamento().subscribe(
        data => {
          this.listDepartamento = data;
          // console.log(data);
          this.departamento = null;
          // this.formModalNotificacion.controls.select_departamento.setValue(null);
        });

      this.parametroService.obtenerParametro(NumIdParamUsuDefCasilla).subscribe(
        data => {

          this.strCodUsuDef = data.cparamValor;

        });

      this.parametroService.obtenerParametro(NumIdLinkRegCasilla).subscribe(
        data => {

          this.strDscLinkCasilla = data.cparamValor;

        });

      // console.log("==================this.data");
      // console.log(this.data);

      // this.formModalNotificacion.controls.select_departamento.setValue(this.data.departamento);
      this.departamento = this.data.departamento;
      this.cambiarDepartamento(this.data.departamento, this.data.provincia);
      this.cambiarProvincia(this.data.provincia, this.data.distrito, this.data.departamento);

      this.strCorreoPN = this.data.correoPN;
      this.strNroDocPN = this.data.nroDocPN;
      this.strDscTipoDocPN = this.data.dscTipoDocPN;

  }


  cambiarDepartamento(idDepartamento: string, idProvincia: string) {

    this.provinciaService.obtenerProvincia(idDepartamento).subscribe(
      data => {
        this.listProvincia = data;

        this.provincia = idProvincia;

        this.distrito = null;
      });

  }

  cambiarProvincia(idProvincia: string, idDistrito: string, idDepartamento: string) {

    this.distritoService.obtenerDistrito(idProvincia, idDepartamento).subscribe(
      data => {
        this.listDistrito = data;

        this.distrito = idDistrito;
      });

  }

  _cambiarAutorizoEmail(evento) {

    this.flgAutorizoEmail = evento.target.checked;

  }

  _cambiarAutorizoActo(evento) {

    this.flgAutorizoActo = evento.target.checked;

  }

  MostrarMedioNotif(idMedNotif: string) {

    this.mostrarCheckCambioEmail = false;
    this.mostrarCheckDireccion = false;
    this.flgMostrarAutoriza = false;
    this.boolFlgCasillaElect = false;
    // console.log("Cambio : " + idMedNotif);

    if (idMedNotif == '1') {

      this.mostrarCambioEmail = false;
      this.mostrarCheckCambioEmail = true;
      this.flgMostrarAutoriza = true;

    } else if (idMedNotif == '2') {

      // this._CambDirNo();
      this.mostrarCambioDireccion = false;

      this.mostrarCheckDireccion = true;

    } else if (idMedNotif == '3') {


      this.boolFlgCasillaElect = true;

    }

  }

  CambioMail(flgEvent) {

    this.mostrarCambioEmail = flgEvent.checked;


  }

  CambioDir(flgEvent) {

    this.mostrarCambioDireccion = flgEvent.checked;


  }


  AceptarModal() {

    const idMN = Number(this.medioNotificacion);
    let strDscDepart = '';
    let strDscProv = '';
    let strDscDist = '';
    const nroDocumentoServicio: NroDocumentoServicio = new NroDocumentoServicio();
    let strDscMsjValCE = '';
    let boolFlgErrValCE = false;
    let numCasoHeigth: number = null;

    // console.log("======idMN",idMN);

    if (!idMN) {

        openModalMensaje(this.strDscTitulo, 'Seleccione el medio de notificación, por favor verifique', this.dialog);
        return;

    }

    if (this.mostrarCheckCambioEmail == true) {

        if (isEmpty(this.strCorreoPN)) {

          openModalMensaje(this.strDscTitulo, 'Debe ingresar primero el correo electrónico del denunciante, por favor verifique', this.dialog);
          return;

        }


        if (this.flgAutorizoEmail == false) {

          openModalMensaje(this.strDscTitulo, 'Debe autorizar el envío de comunicaciones al correo electrónico, por favor verifique', this.dialog);
          return;

        }

    }



    this.dataReturn.flgCampo3 = this.flgAutorizoEmail;
    this.dataReturn.flgCampo4 = this.flgAutorizoActo;
    this.dataReturn.numCampo1 = idMN; // this.formModalNotificacion.controls.select_medNotif.value;
    // this.dataReturn.flgCampo5 = this.mostrarCheckCambioEmail;

    if ( (this.mostrarCheckCambioEmail == true && this.mostrarCambioEmail == false) || (this.mostrarCheckDireccion == true && this.mostrarCambioDireccion == false)) {

      // this.dialogRef.close(this.dataReturn);
      this._cerrarModal();
      return;

    }

    if ( this.mostrarCambioEmail && idMN == NumIdMedioNotifEmail && !ValidarEmail(this.email)) {

        openModalMensaje(this.strDscTitulo, 'Correo electrónico inválido, por favor verifique', this.dialog);
        return;

    }

    this.dataReturn.flgCampo1 = this.mostrarCambioEmail;
    this.dataReturn.flgCampo2 = this.mostrarCambioDireccion;

    // console.log("===this.boolFlgCasillaElect",this.boolFlgCasillaElect);

    if (this.boolFlgCasillaElect == true) {

      if (isEmpty(this.strNroDocPN)) {

        openModalMensaje(this.strDscTitulo, 'Debe ingresar el número de documento de identidad del ciudadano, por favor verifique', this.dialog);
        return;

      }

      nroDocumentoServicio.codUsuario = this.strCodUsuDef;
      nroDocumentoServicio.nroCasilla = this.strNroDocPN;

      this.spinner.show();

      this.laserFicheService.getNroDocumentoServicio(nroDocumentoServicio).subscribe(
        data => {

          this.spinner.hide();

          // console.log("====data getNroDocumentoServicio",data);

          if (data.code != '1') {

            boolFlgErrValCE = true;
            numCasoHeigth = 2;

            strDscMsjValCE = '<p>' + trim(data.message) + '. <br> Para crear una solicitud de generación voluntaria de casilla electrónica puede acceder al siguiente enlace de e-Casilla - CGR : <a href="' + this.strDscLinkCasilla + '" target="_blank">Ver aquí</a> </p>';

          } else {

            strDscMsjValCE = 'e-Casilla - CGR encontrada para ' + this.strDscTipoDocPN + ' :' + this.strNroDocPN;

          }

          openModalMensaje(this.strDscTitulo, strDscMsjValCE, this.dialog, boolFlgErrValCE, numCasoHeigth);

          if (boolFlgErrValCE == true) {

            return;

          } else {

            this._cerrarModal();

          }


        });

    } else {


      if (this.mostrarCambioDireccion == true) {

        strDscDepart = this.listDepartamento.find(x => x.cdptCdDpto == this.departamento).cdptDpto;
        strDscProv = this.listProvincia.find(x => x.cprvCodigo == this.provincia).cprvProv;
        strDscDist = this.listDistrito.find(x => x.cdstCodigo == this.distrito).cdstDistrit;

        this.dataReturn.dscCampo2 = this.direccion + ' ' + strDscDepart + ' ' + strDscProv + ' ' + strDscDist + ' (' +  this.referencia +  ')'; // this.formModalNotificacion.controls.input_dsc_dir.value;
        this.dataReturn.dscCampo6 = this.referencia; // this.formModalNotificacion.controls.input_dsc_ref_dir.value;
        this.dataReturn.dscCampo3 = this.departamento; // this.formModalNotificacion.controls.select_departamento.value;
        this.dataReturn.dscCampo4 = this.provincia; // this.formModalNotificacion.controls.select_provincia.value;
        this.dataReturn.dscCampo5 = this.distrito; // this.formModalNotificacion.controls.select_distrito.value;

      }

      if (this.mostrarCambioEmail == true) {


        this.dataReturn.dscCampo1 = this.email; // this.formModalNotificacion.controls.input_email.value;

      }


      this._cerrarModal();
      // this.dialogRef.close(this.dataReturn);



    }


  }

  _cerrarModal() {

    this.dialogRef.close(this.dataReturn);

  }

  _mayusculas(e, numCaso: number) {

    let vData = '';

    // console.log(e);
    e.target.value = e.target.value.toUpperCase();

    vData = e.target.value; // .trim();

    e.target.value = vData;

    switch (numCaso) {
      case 1:

        this.direccion = vData;

        break;

      case 2:

        this.referencia = vData;

        break;

      default:
        break;
    }



  }


  _cerrar() {
    this.dialogRef.close(null);
  }
}
